<template>
    <div class="row">
        <div class="combobox_mojefirmy" data-app>
            <v-combobox
                v-model="template_name"
                label="Template"
                :items="templateNames"
                filled
            >
            </v-combobox>
        </div>
    </div>
</template>

<script>
export default {
    props: ["template_value"],
    data() {
        return {
            template_type: null,
            template_name: "",
            templates: [
                { id: 0, name: "Default" },
                { id: 6, name: "Vol. 2" },
                { id: 1, name: "Delnet" },
                { id: 2, name: "VeselyCaj" },
                { id: 3, name: "RailJob" },
                { id: 4, name: "Kriejt" },
                { id: 5, name: "Pivovar" },
                { id: 7, name: "DEMISPORT" },
                { id: 8, name: "Auvid" },
                { id: 9, name: "HomeSystem" },
            ],
        };
    },
    created() {
        this.template_type = this.template_value;
        const template = this.templates.find(
            (template) => template.id === this.template_type
        );
        this.template_name = template ? template.name : "Default";
    },
    methods: {
        getIdByName: function () {
            const template = this.templates.find(
                (template) => template.name === this.template_name
            );
            return template
                ? template.id
                : (0, (this.template_name = "Default"));
        },
    },
    computed: {
        templateNames: function () {
            return this.templates.map((template) => template.name);
        },
    },
    watch: {
        template_name: function () {
            this.template_type = this.getIdByName();
        },
        template_type: function () {
            this.$emit("data", this.template_type);
        },
    },
};
</script>

<style lang="scss" scoped>
.combobox_mojefirmy {
    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }
    .v-input {
        height: 56px;
        width: 100%;
    }
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff;
    }
    input {
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 14px !important;
        line-height: 16px !important;
        color: #212541 !important;
    }
    .v-input__slot,
    .theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
        background: #fff !important;
        border: 1px solid #dde3e8 !important;
        border-radius: 0 !important;
        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541 !important;
        }
    }

    .v-text-field > .v-input__control > .v-input__slot {
        &:after {
            content: none !important;
        }
        &:before {
            content: none !important;
        }
    }
    .v-label.v-label--active.theme--light {
        left: -11px !important;
        top: 14px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
    .v-label.theme--light {
        top: 22px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
}
.template_btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    height: 40px;
    border: 1px solid #17a2b8;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    color: #17a2b8;
    padding: 0 10px;
    &:hover {
        color: #fff;
        background: #17a2b8;
    }
    &.active {
        color: #fff;
        background: #17a2b8;
    }
}
</style>
